export const PSD_MIME_TYPES = ["image/vnd.adobe.photoshop", "application/x-photoshop"];
export const ZIP_MIME_TYPE = "application/zip";
